import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { createType, editType, removeType, createGame, editGame, removeGame } from "../../api/Game"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, PlusIcon, InfoIcon, BackIcon, EditIcon, TrashIcon, LayersIcon, SearchIcon, TypeIcon } from "./GameIcons"

/* Switch */
import Switch from "react-switch"

/* Sweet alert */
import Swal from "../../helpers/alert"


/* THE COLORS A CATALOGUE GAME CAN BE PAINTED WITH */
const COLORS = ["lightblue", "blue", "green", "darkgreen", "red", "pink", "purple", "yellow", "orange", "tiffany", "terracotta"]

/* EMPTY EDITOR STATE */
const EMPTY = {

    /* Navigation — "types" or "games", and the editor is closed while the id is null */
    tab: "types",
    search: "",
    filterID: 0,

    /* Editor — the id is 0 while a new row is being created */
    editing: null,
    id: 0,
    key: "",
    name: "",
    typeID: 0,
    prefix: "",
    color: "lightblue",
    live: true,
    rowVisible: true,

    waiting: false,
    error: "",
}


/* Widget Catalog Form */
class CatalogForm extends Component {

    constructor() {
        super()
        this.state = { visible: false, ...EMPTY }
    }

    /* Open Action */
    open = (tab = "types") => {
        this.setState({ visible: true, ...EMPTY, tab })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, ...EMPTY })
    }

    /* Error Message Of A Response */
    message = (response) => {

        /* Check Status */
        if (response && response.status === 409) {
            return response.data && response.data.message ? response.data.message : t("game.error.duplicate")
        }

        /* Check Status */
        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        /* Check Status */
        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        /* Check Message */
        if (response && response.data && response.data.message) {
            return response.data.message
        }

        /* Send Result */
        return t("swal.generic")
    }


    /* Open The Editor Of A Type */
    editType = (item) => {

        /* Check Item — an absent row means a new type */
        if (!item) {
            this.setState({ editing: "type", id: 0, key: "", name: "", live: true, error: "" })
            return
        }

        this.setState({ editing: "type", id: item.id, key: item.key, name: item.name, live: parseInt(item.live) === 1, error: "" })
    }

    /* Open The Editor Of A Game */
    editGame = (item) => {

        /* Fields */
        const { catalog } = this.props
        const { filterID } = this.state

        /* Check Item — an absent row means a new game */
        if (!item) {

            /* The Type Of The Filter Is Preselected */
            const typeID = filterID ? filterID : (catalog.types.length > 0 ? catalog.types[0].id : 0)

            this.setState({ editing: "game", id: 0, key: "", name: "", typeID, prefix: "", color: "lightblue", rowVisible: true, error: "" })
            return
        }

        this.setState({
            editing: "game",
            id: item.id,
            key: item.key,
            name: item.name,
            typeID: item.typeID,
            prefix: item.prefix ? item.prefix : "",
            color: item.color ? item.color : "lightblue",
            rowVisible: parseInt(item.visible) === 1,
            error: "",
        })
    }

    /* Close The Editor */
    cancel = () => {
        this.setState({ editing: null, error: "" })
    }

    /* Finish A Request Of The Editor */
    done = (response) => {

        /* Fields */
        const { reloadCatalog } = this.props

        /* Check Response */
        if (response && response.status === 200) {
            reloadCatalog()
            this.setState({ editing: null, error: "", waiting: false })
            return
        }

        this.setState({ error: this.message(response), waiting: false })
    }


    /* Save The Type */
    saveType = () => {

        /* Fields */
        const { id, key, name, live, waiting } = this.state

        /* Check Waiting */
        if (waiting) {
            return
        }

        /* Check Name */
        if (!name) {
            this.setState({ error: t("game.error.emptyTypeName") })
            return
        }

        /* Check Key — the key of an existing type is never changed, it is the column Tables.type */
        if (!id && (!key || /[^a-z0-9-]/.test(key))) {
            this.setState({ error: t("game.error.invalidTypeKey") })
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true, error: "" })

        /* Send to REST API */
        const request = id ? editType({ id, name, live: live ? 1 : 0 }) : createType({ key, name, live: live ? 1 : 0 })

        request.then((response) => this.done(response)).catch(() => this.done(null))
    }

    /* Save The Game */
    saveGame = () => {

        /* Fields */
        const { id, key, name, typeID, prefix, color, rowVisible, waiting } = this.state

        /* Check Waiting */
        if (waiting) {
            return
        }

        /* Check Type */
        if (!typeID) {
            this.setState({ error: t("game.error.selectType") })
            return
        }

        /* Check Name */
        if (!name) {
            this.setState({ error: t("game.error.emptyGameName") })
            return
        }

        /* Check Key — the key of an existing game is never changed, it is Tables.game and the route of the panel */
        if (!id && (!key || /[^a-z0-9-]/.test(key))) {
            this.setState({ error: t("game.error.invalidGameKey") })
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true, error: "" })

        /* Send to REST API */
        const data = { typeID, name, prefix, color, visible: rowVisible ? 1 : 0 }
        const request = id ? editGame({ ...data, id }) : createGame({ ...data, key })

        request.then((response) => this.done(response)).catch(() => this.done(null))
    }

    /* Remove A Row Of The Catalogue */
    remove = (kind, item) => {

        /* Fields */
        const { reloadCatalog } = this.props

        Swal.fire({
            title: t("swal.deleteConfirm"),
            text: item.name,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("swal.deleteButton"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {

            /* Check Confirmation */
            if (!result.isConfirmed) {
                return
            }

            /* Send to REST API */
            const request = kind === "type" ? removeType({ id: item.id }) : removeGame({ id: item.id })

            request.then((response) => {
                if (response && response.status === 200) {
                    reloadCatalog()
                    this.setState({ editing: null })
                }
                else {
                    Swal.fire(utils.notification(this.message(response), "error"))
                }
            }).catch(() => {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            })
        })
    }


    /* Draw A Field */
    _field = (label, value, onChange, options = {}) => (
        <div className={`gm--field ${options.full ? "gm--full" : ""}`}>

            <label>{label}{options.required ? <i>*</i> : null}</label>

            <input value={value} disabled={options.disabled ? true : false} placeholder={options.placeholder ? options.placeholder : ""} onChange={(event) => onChange(event.target.value)} />

            {options.hint ? <small>{options.hint}</small> : null}

        </div>
    )

    /* Draw The List Of The Types */
    _types = () => {

        /* Fields */
        const { catalog } = this.props
        const { search } = this.state

        /* Filter By Search */
        const value = search.toLowerCase()
        const list = catalog.types.filter((item) => !value || `${item.name} ${item.key}`.toLowerCase().includes(value))

        return (
            <div className="gm--rows">

                {list.map((item) =>
                    <div className="gm--row" key={`${item.id}`}>

                        <div className="gm--row-icon"><TypeIcon type={item.key} size={17} /></div>

                        <div className="gm--row-text">
                            <b>{item.name}</b>
                            <span>{item.key} · {catalog.games.filter((game) => parseInt(game.typeID) === parseInt(item.id)).length} {t("game.gamesCount")}</span>
                        </div>

                        <div className="gm--row-tags">
                            {parseInt(item.live) === 1 ? <div className="gm--tag live">Live</div> : <div className="gm--tag">RNG</div>}
                        </div>

                        <div className="gm--row-actions">

                            <div onClick={() => this.editType(item)} className="gm--icon-button"><EditIcon /></div>
                            <div onClick={() => this.remove("type", item)} className="gm--icon-button danger"><TrashIcon /></div>

                        </div>

                    </div>
                )}

                {list.length === 0 ? <div className="gm--empty">{t("game.emptyList")}</div> : null}

            </div>
        )
    }

    /* Draw The List Of The Games */
    _games = () => {

        /* Fields */
        const { catalog } = this.props
        const { search, filterID } = this.state

        /* Filter By The Type And The Search */
        const value = search.toLowerCase()
        const list = catalog.games.filter((item) => {

            /* Check The Type */
            if (filterID && parseInt(item.typeID) !== parseInt(filterID)) {
                return false
            }

            /* Check The Search */
            return !value || `${item.name} ${item.key} ${item.prefix}`.toLowerCase().includes(value)
        })

        return (
            <div className="gm--rows">

                {list.map((item) => {

                    /* The Type Of The Game */
                    const type = catalog.types.find((row) => parseInt(row.id) === parseInt(item.typeID))

                    return (
                        <div className={`gm--row ${item.color}`} key={`${item.id}`}>

                            <div className="gm--row-dot" />

                            <div className="gm--row-text">
                                <b>{item.name}</b>
                                <span>{item.key}{item.prefix ? ` · ${item.prefix}` : ""}{type ? ` · ${type.name}` : ""}</span>
                            </div>

                            <div className="gm--row-tags">
                                {parseInt(item.visible) === 1 ? null : <div className="gm--tag hidden">{t("common.disabled")}</div>}
                            </div>

                            <div className="gm--row-actions">

                                <div onClick={() => this.editGame(item)} className="gm--icon-button"><EditIcon /></div>
                                <div onClick={() => this.remove("game", item)} className="gm--icon-button danger"><TrashIcon /></div>

                            </div>

                        </div>
                    )
                })}

                {list.length === 0 ? <div className="gm--empty">{t("game.emptyList")}</div> : null}

            </div>
        )
    }

    /* Draw The Editor Of A Type */
    _typeEditor = () => {

        /* Fields */
        const { id, key, name, live } = this.state

        return (
            <div className="gm--section">

                <div className="gm--section-title">
                    <LayersIcon size={13} />
                    {id ? t("game.editType") : t("game.addType")}
                </div>

                <div className="gm--grid">

                    {this._field(t("game.typeName"), name, (value) => this.setState({ name: value }), { required: true })}
                    {this._field(t("game.typeKey"), key, (value) => this.setState({ key: value.toLowerCase() }), { required: !id, disabled: id ? true : false, hint: id ? t("game.keyLocked") : t("game.keyHint") })}

                    <div className="gm--field gm--full">

                        <div className="gm--switch">

                            <div className="gm--switch-text">
                                <b>{t("game.liveType")}</b>
                                <span>{t("game.liveHint")}</span>
                            </div>

                            <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ live: value })} checked={live} />

                        </div>

                    </div>

                </div>

            </div>
        )
    }

    /* Draw The Editor Of A Game */
    _gameEditor = () => {

        /* Fields */
        const { catalog } = this.props
        const { id, key, name, typeID, prefix, color, rowVisible } = this.state

        return (
            <div className="gm--section">

                <div className="gm--section-title">
                    <LayersIcon size={13} />
                    {id ? t("game.editCatalogGame") : t("game.addCatalogGame")}
                </div>

                <div className="gm--grid">

                    {this._field(t("game.gameName"), name, (value) => this.setState({ name: value }), { required: true })}

                    <div className="gm--field">

                        <label>{t("game.typeSection")}<i>*</i></label>

                        <select value={`${typeID}`} onChange={(event) => this.setState({ typeID: event.target.value })}>
                            {catalog.types.map((item) => <option value={`${item.id}`} key={`${item.id}`}>{item.name}</option>)}
                        </select>

                    </div>

                    {this._field(t("game.gameKey"), key, (value) => this.setState({ key: value.toLowerCase() }), { required: !id, disabled: id ? true : false, hint: id ? t("game.keyLocked") : t("game.gameKeyHint") })}
                    {this._field(t("game.gamePrefix"), prefix, (value) => this.setState({ prefix: value.toUpperCase() }), { hint: t("game.prefixHint") })}

                    <div className="gm--field gm--full">

                        <label>{t("game.gameColor")}</label>

                        <div className="gm--colors">
                            {COLORS.map((item) =>
                                <div onClick={() => this.setState({ color: item })} className={`gm--color ${item} ${color === item ? "active" : ""}`} key={item} />
                            )}
                        </div>

                    </div>

                    <div className="gm--field gm--full">

                        <div className="gm--switch">

                            <div className="gm--switch-text">
                                <b>{t("game.gameVisibility")}</b>
                                <span>{t("game.gameVisibilityHint")}</span>
                            </div>

                            <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ rowVisible: value })} checked={rowVisible} />

                        </div>

                    </div>

                </div>

                <div className="gm--hint">
                    <InfoIcon size={14} />
                    <span>{t("game.catalogHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { catalog } = this.props
        const { visible, tab, search, filterID, editing, waiting, error } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="gm--modal"
                overlayClassName="gm--overlay gm--overlay-top"
                closeTimeoutMS={200}
            >

                <div className="gm--head">

                    <div className="gm--head-icon">
                        <LayersIcon size={18} />
                    </div>

                    <div className="gm--head-text">
                        <h2>{t("game.catalogTitle")}</h2>
                        <p>{t("game.catalogSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="gm--close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="gm--body">

                    <div className="gm--content">

                        {
                            editing ?
                                editing === "type" ? this._typeEditor() : this._gameEditor()
                                :
                                <div>

                                    <div className="gm--tabs">
                                        <div onClick={() => this.setState({ tab: "types", search: "" })} className={`gm--tab ${tab === "types" ? "active" : ""}`}>{t("game.tabTypes")}</div>
                                        <div onClick={() => this.setState({ tab: "games", search: "" })} className={`gm--tab ${tab === "games" ? "active" : ""}`}>{t("game.tabGames")}</div>
                                    </div>

                                    <div className="gm--section-head">

                                        <div className="gm--search">
                                            <SearchIcon />
                                            <input value={search} placeholder={t("common.search")} onChange={(event) => this.setState({ search: event.target.value })} />
                                        </div>

                                        {
                                            tab === "games" ?
                                                <div className="gm--field">
                                                    <select value={`${filterID}`} onChange={(event) => this.setState({ filterID: event.target.value })}>
                                                        <option value="0">{t("game.allTypes")}</option>
                                                        {catalog.types.map((item) => <option value={`${item.id}`} key={`${item.id}`}>{item.name}</option>)}
                                                    </select>
                                                </div>
                                                : null
                                        }

                                        <div onClick={() => tab === "types" ? this.editType(null) : this.editGame(null)} className="gm--button primary small">
                                            <PlusIcon size={14} />
                                            {tab === "types" ? t("game.addType") : t("game.addCatalogGame")}
                                        </div>

                                    </div>

                                    {tab === "types" ? this._types() : this._games()}

                                </div>
                        }

                    </div>

                </div>

                <div className="gm--foot">

                    <div className="gm--foot-note">{error ? error : ""}</div>

                    {
                        editing ?
                            <>
                                <div onClick={() => this.cancel()} className="gm--button ghost"><BackIcon />{t("common.back")}</div>

                                <div onClick={() => editing === "type" ? this.saveType() : this.saveGame()} className={`gm--button primary ${waiting ? "waiting" : ""}`}>
                                    {waiting ? <div className="gm--loading" /> : t("common.save")}
                                </div>
                            </>
                            :
                            <div onClick={() => this.close()} className="gm--button ghost">{t("common.close")}</div>
                    }

                </div>

            </Modal>
        )
    }
}


const mapStateToProps = (state) => ({
    language: state.language,
    catalog: state.catalog,
    admin: state.admin,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(CatalogForm)
